/** CodeEdit registration: the parser. `index.r3f.ts` wires the render component. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCodeEdit } from './parser';
const codeEditRegistration = {
    typeName: 'CodeEdit',
    parser: parseCodeEdit,
};
nodeRegistry.register(codeEditRegistration);
//# sourceMappingURL=index.js.map